import type { CustomIconProps } from '../types';

const Info = ({ width, height, color, dataTestId, ...props }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
        data-testid={dataTestId}
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6.13 3.26C5.794 3.26 5.5 2.994 5.5 2.63C5.5 2.266 5.794 2 6.13 2C6.48 2 6.774 2.266 6.774 2.63C6.774 2.994 6.48 3.26 6.13 3.26ZM5.63 9.72996H6.63L6.63006 4.72998H5.63006L5.63 9.72996Z"
            fill={color ?? '#414042'}
        />
    </svg>
);

export default Info;
